import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Message from '../common/message/Message';
import Spacer from '../common/spacer/Spacer';
import Text from '../common/text/Text';
import Svg from '../common/svg/Svg';
import {ExpandButton} from '../prize/ExpandButton';

import {useToggle} from '../../hooks/useToggle';
import { PROGRESS } from '../../constants/ProgressStates';
import svgs from '../../constants/svgs';

export function ProgressItem(props) {
    const {
        children,
        expanded,
        step,
        status,
        title,
        expandedProps,
        ...otherProps
    } = props;

    const isActive = status === PROGRESS.ACTIVE;
    const [isExpanded, toggle] = useToggle(expanded || isActive);

    return (
        <Spacer
            className={cx(
                'progstep',
                isActive && 'progstep--active'
            )}
            {...otherProps}
        >
            <div
                className={cx(
                    'progstep__header',
                    isActive && 'progstep__header--active'
                )}
            >
                <Svg
                    image={status === PROGRESS.COMPLETE ? svgs.CHECKED : svgs.UNCHECKED}
                    right={28}
                    size={16}
                />
                <Text as="h3" size={14}>
                    <Message fragment code="epic.esport.labels.step" args={[step]} />
                    <Text
                        className={cx(
                            'progstep__title',
                            !isActive && 'progstep__title--inactive'
                        )}
                        left={4}
                        size={null}
                    >
                        {title}
                    </Text>
                </Text>

                {isActive &&
                    <span className="prog__current">
                        <Message fragment code="epic.esport.labels.currentStep" />
                    </span>
                }

                <ExpandButton
                    expanded={isExpanded}
                    onClick={toggle}
                    className="expandbtn__prog"
                />
            </div>
            <Spacer
                className={cx(
                    'progstep__expanded',
                    isExpanded && 'progstep__expanded--active'
                )}
                {...expandedProps}
            >
                {children}
            </Spacer>
        </Spacer>
    );
}

ProgressItem.displayName = 'ProgressItem';

ProgressItem.propTypes = {
    children: PropTypes.node,
    expanded: PropTypes.bool,
    expandedProps: PropTypes.object,
    status: PropTypes.oneOf(Object.values(PROGRESS)),
    step: PropTypes.number,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
